function abbreviateName(fullName: string): string {
  const names = fullName
    .trim()
    .split(' ')
    .filter((name) => Boolean(name));
  let abbreviation = '';

  if (names.length === 0) {
    return abbreviation;
  }

  if (names.length === 3) {
    names.splice(1, 1);
  }

  for (let i = 0; i < names.length - 1; i++) {
    if (names[i].includes('-')) {
      const shortenedParts = names[i]
        .split('-')
        .filter((namePart) => Boolean(namePart))
        .map((namePart) => namePart[0].toUpperCase() + '.')
        .join('-');

      if (shortenedParts) {
        abbreviation += shortenedParts;
        abbreviation += ' ';
      }
    } else {
      abbreviation += names[i][0].toUpperCase() + '. ';
    }
  }

  abbreviation += names[names.length - 1];

  return abbreviation;
}

export { abbreviateName };
